// src/views/Users/Customers/Customers.jsx
import { useState, useEffect, useRef } from "react";
import { globalConstants, modeConstants } from "../../../constants";
import { useDispatch, useSelector } from "react-redux";
import ActionsDataTable from "../../../shared/ActionsDataTable";
import { userActions } from "../../../redux/actions";
import UserModal from "../../../shared/UserModal";
import { getUserData, SCREENS_IDS } from "../../../system";

export default function Users() {
  const initialGridState = {
    length: 10,
    pageNumber: 1,
    orderBy: "",
    filterQuery: null,
    search: null,
    filterExpression: globalConstants.FILTER_EXPRESSION,
  };

  const dispatch = useDispatch();
  const sortingInProgressRef = useRef(false);
  const decryptedData = getUserData();

  const [gridState, setGridState] = useState(initialGridState);
  const [defaultPage, setDefaultPage] = useState(initialGridState.pageNumber);
  // modal + row state
  const [mode, setMode] = useState(modeConstants.ADD_MODE);
  const [showUserModal, setShowUserModal] = useState(false);
  const [rowData, setRowData] = useState([]);
  const allData = useSelector((s) => s.userReducer.data);

  let allowToolbar = decryptedData.user_permissions.some(
    (perm) => perm.permission_id === SCREENS_IDS.CAN_CREATE_USER
  );

  let allowEdit = decryptedData.user_permissions.some(
    (perm) => perm.permission_id === SCREENS_IDS.CAN_EDIT_USER
  );

  let allowDelete = decryptedData.user_permissions.some(
    (perm) => perm.permission_id === SCREENS_IDS.CAN_DELETE_USER
  );

  // filters aligned to table fields
  const filterColumns = [];

  const columns = [
    {
      name: "Sr. No",
      selector: (row, index) => index + 1, // start from 1
      sortable: false,
      width: "100px",
    },
    {
      id: "name",
      name: "Name",
      selector: (r) => r.name,
      sortable: true,
      grow: 1.6,
    },
    {
      id: "email",
      name: "Email",
      cell: (r) => <div className="email-wrap">{r.email}</div>,
      sortable: true,
      grow: 1.6,
    },
    {
      id: "phone_number",
      name: "Phone Number",
      selector: (r) => r.phone_number,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <div className="d-flex align-items-center">
          <span>{row.phone_number}</span>
        </div>
      ),
    },
    // {
    //   id: "is_alert_allowed",
    //   name: "Alerts Allowed",
    //   selector: (r) => (r.is_alert_allowed ? "Yes" : "No"),
    //   sortable: true,
    //   grow: 1.6,
    // },
    // Toggle
    {
      id: "is_active",
      name: "IsActive",
      sortable: false,
      width: "110px",
      selector: (r) => r.is_active,
      cell: (row) => (
        <div
          className="form-check form-switch m-0"
          onClick={(e) => e.stopPropagation()}
          title={row.is_active == 1 ? "Active" : "Inactive"}
        >
          <input
            className="form-check-input"
            type="checkbox"
            role="switch"
            checked={row.is_active == 1 ? true : false}
            onChange={() => {
              toggleStatus(row.id);
            }}
            aria-checked={row.is_active == 1 ? true : false}
          />
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    // Actions
    {
      name: "Actions",
      sortable: false,
      width: "170px",
      cell: (row) => (
        <div
          className="d-flex align-items-center gap-2"
          onClick={(e) => e.stopPropagation()}
        >
          {allowEdit && (
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              title="Edit"
              aria-label="Edit"
              onClick={() => {
                getRowData(row, modeConstants.UPDATE_MODE);
                setShowUserModal(true);
              }}
            >
              <i className="bi bi-pencil" />
            </button>
          )}
          {allowDelete && (
            <button
              type="button"
              className="btn btn-sm btn-outline-danger"
              title="Edit"
              aria-label="Edit"
              onClick={() => {
                deleteRow(row);
              }}
            >
              <i className="bi bi-trash" />
            </button>
          )}
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const getRowData = (row, nextMode) => {
    dispatch(userActions.getUserById(row.id));
    setMode(nextMode);
  };

  const toggleStatus = (id) => {
    dispatch(userActions.deleteUserById(id));
  };

  const deleteRow = (row) => {
    dispatch(userActions.deleteUserPermanentById(row.id));
  };

  const onSort = (sortedColumn, sortDirection) => {
    sortingInProgressRef.current = true;
    const columnDirection = sortDirection
      ? sortDirection.toUpperCase() // "ASC" | "DESC"
      : null;
    setDefaultPage(gridState.pageNumber);
    setGridState((prevState) => ({
      ...prevState,
      orderBy:
        columnDirection !== null ? `${sortedColumn.id} ${columnDirection}` : "",
    }));
  };

  const onChangePage = (pageNumber) => {
    if (!sortingInProgressRef.current) {
      setGridState((prevState) => ({
        ...prevState,
        pageNumber: pageNumber,
      }));
    }
  };

  const onChangeRowsPerPage = (newPerPage, pageNumber) => {
    setGridState((prevState) => ({
      ...prevState,
      length: newPerPage,
      pageNumber: pageNumber,
    }));
  };

  const getAll = () => {
    dispatch(userActions.getAllUser());
    dispatch(userActions.getPermissions());
  };
  useEffect(() => {
    if (allData !== null) {
      setRowData(allData);
    }
    // eslint-disable-next-line
  }, [allData]);

  useEffect(() => {
    // getAll();
    sortingInProgressRef.current = false;
    // eslint-disable-next-line
  }, [gridState]);

  useEffect(() => {
    getAll();
  }, []);

  console.log("data", rowData);

  return (
    <>
      <UserModal
        show={showUserModal}
        onHide={() => setShowUserModal(false)}
        mode={mode}
      />

      <ActionsDataTable
        columns={columns}
        filterColumns={filterColumns}
        data={rowData}
        pagination
        highlightOnHover
        striped
        responsive
        persistTableHead
        selectableRows
        selectableRowsHighlight
        selectableRowsVisibleOnly
        paginationServer={false}
        onSort={onSort}
        gridState={gridState}
        paginationTotalRows={rowData.length}
        onChangeRowsPerPage={onChangeRowsPerPage}
        onChangePage={onChangePage}
        paginationDefaultPage={defaultPage}
        paginationResetDefaultPage
        setShowModal={setShowUserModal}
        setMode={setMode}
        setGridState={setGridState}
        allowToolbar = {allowToolbar}
        allowFilters = {false}
        title="Users"
      />
    </>
  );
}
